import type { ChromeCopy } from './types'

export const te: ChromeCopy = {
  appName: 'సమ్ఝో',
  tagline: 'కాగితాన్ని అర్థం చేసుకోండి. తర్వాత ఏమి చేయాలో తెలుసుకోండి.',
  savedTitle: 'సేవ్ చేసిన కాగితాలు',
  upcomingTitle: 'రాబోయే చివరి తేదీలు',
  markDone: 'పూర్తయిందని గుర్తించండి',
  doneLabel: 'పూర్తయింది',
  deadlineCheckIn: 'సేవ్ చేసిన {n} కాగితాల చివరి తేదీ దగ్గర పడింది. పూర్తి చేశారా?',
  savedHint: 'ఇవి ఈ ఫోన్‌లో మాత్రమే ఉన్నాయి. ఫోటో, పూర్తి రాత ఎప్పుడూ సేవ్ కావు — ముఖ్యమైన వివరాలు మాత్రమే.',
  emptySaved: 'ఇంకా ఏ కాగితమూ సేవ్ చేయలేదు.',
  clearAll: 'అన్నీ తొలగించండి',
  deleteItem: 'తొలగించండి',
  aboutTitle: 'గోప్యత, ముఖ్యమైన సమాచారం',
  privacyPoints: [
    'మీ కాగితం ఫోటో, అందులోని రాత ఈ ఫోన్‌లోనే చదివి వివరించబడతాయి. ఫోటో ఎక్కడికీ అప్‌లోడ్ కాదు.',
    'మీరు "సేవ్ చేయండి" నొక్కితే తప్ప ఏదీ సేవ్ కాదు. "కొత్త కాగితం" నొక్కగానే, ముందటి కాగితం స్క్రీన్ నుండి, మెమరీ నుండి తీసేయబడుతుంది.',
    'సేవ్ చేసినప్పుడు, ముఖ్యమైన వివరాలు (తేదీలు, మొత్తాలు, నంబర్లు) మాత్రమే, ఈ ఫోన్‌లో మాత్రమే ఉంచబడతాయి — ఫోటో గానీ పూర్తి రాత గానీ కాదు. వీటిని మీరు ఎప్పుడైనా తొలగించవచ్చు.',
    'ఇంటర్నెట్ మూడు పనులకు మాత్రమే వాడబడుతుంది: మొదటిసారి చదివే టూల్‌ను, గొంతులను (సమ్ఝో సొంత సైట్ నుండి) డౌన్‌లోడ్ చేయడానికి, మరియు — మీరు అడిగితేనే — కాగితంలోని ఇంగ్లీష్ లైన్లను అనువదించడానికి. అనువాదం కోసం పంపిన లైన్లు సేవ్ కావు, ఆధార్, ఫోన్ లాంటి నంబర్లు ముందే తీసేయబడతాయి. మూడవది — మీరు ప్రశ్న అడిగితేనే: జవాబు రాయడానికి కాగితంలోని రాత, మీ ప్రశ్న సమ్ఝో సర్వర్‌కి, ఒక AI సేవకు (Groq) వెళ్తాయి; ఆధార్, పాన్, ఫోన్, ఈమెయిల్ ముందే తీసేయబడతాయి. ప్రభుత్వ వెబ్‌సైట్లు మాత్రమే చూడబడతాయి, ఏదీ సేవ్ కాదు. ఇంగ్లీష్‌లో లేని లైన్లను ఒక AI సేవ (Groq) అనువదిస్తుంది.',
    'సమ్ఝోలో ప్రకటనలు లేవు. ఎంతమంది యాప్ తెరుస్తున్నారో మాత్రమే మేము లెక్కపెడతాము (Cloudflare Web Analytics, కుకీలు లేకుండా). మీ కాగితంలోని ఏదీ అందులో చేరదు, కాగితంలోని విషయాలు ఎప్పుడూ లాగ్ చేయబడవు.'
  ],
  disclaimerTitle: 'ఇది అధికారిక లేదా చట్టపరమైన సలహా కాదు',
  disclaimer: 'సమ్ఝో ఒక స్వతంత్ర సహాయ టూల్, ప్రభుత్వ వెబ్‌సైట్ కాదు. ఇది మీ కాగితాన్ని సులభంగా వివరిస్తుంది, కానీ దాని వివరణ అధికారికమైనది గానీ చట్టపరమైనది గానీ కాదు. ముఖ్యమైన వివరాలను ఎప్పుడూ అసలు కాగితంతో లేదా దాన్ని ఇచ్చిన ఆఫీసుతో సరిచూసుకోండి.',
  contactTitle: 'ఏదైనా సమస్య ఉందా?',
  contact: 'ఏదైనా సమస్య ఉంటే, ఈ ఈమెయిల్‌లో మమ్మల్ని సంప్రదించండి:',
  freeTitle: 'పూర్తిగా ఉచితం',
  free: 'సమ్ఝో ఓపెన్-సోర్స్ టూల్స్‌తో పనిచేస్తుంది: చదవడానికి Tesseract, వినిపించడానికి మీ ఫోన్ సొంత గొంతు లేదా Meta వారి ఓపెన్ MMS గొంతులు (CC BY-NC 4.0). అకౌంట్ అక్కర్లేదు, డబ్బు కట్టక్కర్లేదు.',
  shareApp: 'WhatsAppలో షేర్ చేయండి',
  installApp: 'యాప్‌ను ఫోన్‌లో చేర్చండి',
  offline: 'ఇప్పుడు ఇంటర్నెట్ లేదు',
  offlineHint: 'ఇంతకు ముందు సమ్ఝో వాడి ఉంటే, ఇంటర్నెట్ లేకపోయినా కాగితాలను చదవవచ్చు.',
  shareAppMessage: 'ప్రభుత్వ కాగితాలను సులభమైన భాషలో అర్థం చేసుకోవడానికి, వినడానికి సమ్ఝో (SAMJHO) వాడండి (ఉచితం):\nhttps://samjho.pages.dev'
}
